var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("i", {
    staticClass: "iconfont",
    class: [_vm.isFullscreen ? "icon-minimize" : "icon-maximize"],
    staticStyle: { display: "block" },
    on: { click: _vm.onScreenFullClick },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }